import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import all from './all';

const Charts = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/all`}/>
      <Route path={`${match.url}/all`} component={all}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default Charts;
